import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { inject, runInInjectionContext } from '@angular/core';
import { NotificationReasonEnum } from '../../enums/notification/notification-reason.enum';
import { MessageDesignBUtils } from '../../content/components/message-design-b/message-design-b.utils';
import { AuthserviceService } from '../../content/pages-new-design/auth-page/login-page/authservice.service';
import { HeaderClientService } from '../../services/client/header-service/header-client.service';
import { IdentityRequestService } from '../../services/request/identity-request.service';
import { TakenOverIdentity } from '../../models/rights/identity/taken-over-identity.model';

export class SseCommunityEvent extends SseEventBase {

  type: SseEventType = 'community';
  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    if (this.hasEvents(resp)) {
      runInInjectionContext(this.injector, () => {
        resp.events.forEach(event => this.onEvent(resp, event));
      });
    }
  }

  private onEvent(resp: any, event: NotificationReasonEnum): void {
    this.ngZone.run(() => {
      switch (event) {
        case NotificationReasonEnum.COMMUNITY_ORG_UPDATE: {
          this.on.communityOrgChanged$.next(true);
          break;
        }
      }
    });
  }
}
